export interface AgentVoice {
  voice_id: string;
  name: string;
  provider_name: 'eleven_labs' | 'deepgram';
  provider_props: ElevenLabsProps | DeepgramProps;
  sample_audio: string;
  languages: {
    language: string;
    sample_audio?: string;
  }[];
  gender: string;
  description: string;
}

export interface ElevenLabsProps {
  description: string;
  labels: {
    accent: string;
    descriptive?: string;
    age: string;
    gender: string;
    language?: string;
    use_case?: string;
  };
}

export interface DeepgramProps {
  metadata: {
    accent: string;
    age: string;
    color: string;
    image: string;
    sample: string;
    tags: string[];
    use_cases: string[];
  };
}

const ELEVEN_LABS_VOICES: AgentVoice[] = [
  {
    voice_id: '9BWtsMINqrJLrRacOk9x',
    name: 'Aria',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'A middle-aged female with an African-American accent. Calm with a hint of rasp.',
      labels: {
        accent: 'american',
        descriptive: 'husky',
        age: 'middle_aged',
        gender: 'female',
        language: 'en',
        use_case: 'informative_educational'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/405766b8-1f4e-4d3c-aba1-6f25333823ec.mp3',
    gender: 'female',
    description:
      'A middle-aged American female voice with a calm, husky tone that carries a hint of rasp. Ideal for informative and educational content.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/405766b8-1f4e-4d3c-aba1-6f25333823ec.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/405766b8-1f4e-4d3c-aba1-6f25333823ec.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/405766b8-1f4e-4d3c-aba1-6f25333823ec.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/405766b8-1f4e-4d3c-aba1-6f25333823ec.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/405766b8-1f4e-4d3c-aba1-6f25333823ec.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/405766b8-1f4e-4d3c-aba1-6f25333823ec.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/405766b8-1f4e-4d3c-aba1-6f25333823ec.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/ae97c224-d4d0-4e03-a9ab-36f031f48e94.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/b6a58993-1cf7-4ea8-b3b1-a60b3641d5bf.mp3'
      },
      {
        language: 'tr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/9BWtsMINqrJLrRacOk9x/9342915e-dd15-4a11-af37-96670decd65a.mp3'
      }
    ]
  },
  {
    voice_id: 'EXAVITQu4vr4xnSDxMaL',
    name: 'Sarah',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'Young adult woman with a confident and warm, mature quality and a reassuring, professional tone.',
      labels: {
        accent: 'american',
        descriptive: 'professional',
        age: 'young',
        gender: 'female',
        language: 'en',
        use_case: 'entertainment_tv'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/01a3e33c-6e99-4ee7-8543-ff2216a32186.mp3',
    gender: 'female',
    description:
      'A young American female voice that is confident, warm, and professional. Her reassuring and mature tone is well-suited for entertainment and TV applications.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/01a3e33c-6e99-4ee7-8543-ff2216a32186.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/01a3e33c-6e99-4ee7-8543-ff2216a32186.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/01a3e33c-6e99-4ee7-8543-ff2216a32186.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/093154f2-dd9f-4a4c-b5c3-81836c7ac3f6.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/ecb43dfe-b9f3-4691-8ee8-90c5ad3f4dbb.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/d9b9f54d-c08b-426e-80f3-b4f2089c3a59.mp3'
      },
      {
        language: 'es',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/57ab5344-ed96-46fc-b319-82dc1c89bf66.mp3'
      },
      {
        language: 'hi',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/EXAVITQu4vr4xnSDxMaL/2f2caaae-ad5e-4ff2-a084-7a6067913a69.mp3'
      }
    ]
  },
  {
    voice_id: 'FGY2WhTYpPnrIDTdsKH5',
    name: 'Laura',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'This young adult female voice delivers sunny enthusiasm with a quirky attitude.',
      labels: {
        accent: 'american',
        descriptive: 'sassy',
        age: 'young',
        gender: 'female',
        language: 'en',
        use_case: 'social_media'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3',
    gender: 'female',
    description:
      'A young American female voice with a sassy, enthusiastic, and quirky attitude. Perfect for social media content that needs a touch of sunny energy.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/67341759-ad08-41a5-be6e-de12fe448618.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/21082ee9-c176-4454-ac50-54bdf230ef49.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/ec8fcd73-ed00-4478-ad2f-0dca5c5a5583.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/56e58899-8324-4908-a617-3e7710251c39.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/FGY2WhTYpPnrIDTdsKH5/210e72ad-ba9e-475e-9e18-000bc7cd771c.mp3'
      }
    ]
  },
  {
    voice_id: 'IKne3meq5aSn9XLyUdCD',
    name: 'Charlie',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'A young Australian male with a confident and energetic voice.',
      labels: {
        accent: 'australian',
        descriptive: 'hyped',
        age: 'young',
        gender: 'male',
        language: 'en',
        use_case: 'conversational'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3',
    gender: 'male',
    description:
      'A young Australian male voice, confident and energetic. His hyped delivery is great for conversational content.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/102de6f2-22ed-43e0-a1f1-111fa75c5481.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/51392837-4691-4e9c-a11d-658848033ace.mp3'
      },
      {
        language: 'pt',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/f1d38c1a-b69a-44f5-9d91-76d17dcce479.mp3'
      },
      {
        language: 'fil',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/7eae8500-ea92-47c1-95fc-394cf3bc45d2.mp3'
      },
      {
        language: 'es',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/IKne3meq5aSn9XLyUdCD/52f3846a-eee1-43e4-bcd1-0280f20fe202.mp3'
      }
    ]
  },
  {
    voice_id: 'JBFqnCBsd6RMkjVDRZzb',
    name: 'George',
    provider_name: 'eleven_labs',
    provider_props: {
      description: 'Warm resonance that instantly captivates listeners.',
      labels: {
        accent: 'british',
        descriptive: 'mature',
        age: 'middle_aged',
        gender: 'male',
        language: 'en',
        use_case: 'narrative_story'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3',
    gender: 'male',
    description:
      'A middle-aged British male voice with a warm, mature, and captivating resonance. Excellent for narrative storytelling.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/e6206d1a-0721-4787-aafb-06a6e705cac5.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/6096acce-e18f-4e95-a8e3-bb1c0a27624e.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/0ece09f9-7d3e-4031-af75-936aa0cda577.mp3'
      },
      {
        language: 'ja',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/709a894a-d0d1-46d7-9c10-3b140e3a69f2.mp3'
      },
      {
        language: 'cs',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/4347a4c3-142a-4490-9777-00671ef3855c.mp3'
      },
      {
        language: 'fil',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/924cfaf5-c7db-49fe-b835-7d37ca424314.mp3'
      },
      {
        language: 'es',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/eae50a0d-5a39-4795-9b1e-1d58f7f87e63.mp3'
      },
      {
        language: 'hi',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/JBFqnCBsd6RMkjVDRZzb/15c58de3-5d6c-461a-8111-c473fd185573.mp3'
      }
    ]
  },
  {
    voice_id: 'N2lVS1w4EtoT3dr4eOWO',
    name: 'Callum',
    provider_name: 'eleven_labs',
    provider_props: {
      description: 'Deceptively gravelly, yet unsettling edge.',
      labels: {
        accent: '', // Accent not specified, so won't include in description
        age: 'middle_aged',
        language: 'en',
        gender: 'male',
        use_case: 'characters'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3',
    gender: 'male',
    description:
      'A middle-aged male voice with a deceptively gravelly tone and an unsettling edge. Ideal for character roles.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/ac833bd8-ffda-4938-9ebc-b0f99ca25481.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/cae55f06-da58-4810-ad48-5e6eb0fe72a9.mp3'
      },
      {
        language: 'hi',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/N2lVS1w4EtoT3dr4eOWO/b4465e6f-051d-4e0b-b588-617ff34de35b.mp3'
      }
    ]
  },
  {
    voice_id: 'SAz9YHcvj6GT2YYXdXww',
    name: 'River',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'A relaxed, neutral voice ready for narrations or conversational projects.',
      labels: {
        accent: 'american',
        descriptive: 'calm',
        age: 'middle_aged',
        gender: 'neutral',
        language: 'en',
        use_case: 'conversational'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3',
    gender: 'neutral',
    description:
      'A middle-aged American neutral voice, relaxed and calm. Well-suited for narrations or conversational projects.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/e6c95f0b-2227-491a-b3d7-2249240decb7.mp3'
      },
      {
        language: 'it',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/62da5f17-c5cb-48bb-ad7c-e0b7623d16cc.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/cd628aed-b6a3-463a-b96f-1e7eebd34f04.mp3'
      },
      {
        language: 'pt',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/81a2500f-c016-4ca1-a9b9-09ab065a084f.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/SAz9YHcvj6GT2YYXdXww/cf733b36-9256-4224-9890-20c67ada259c.mp3'
      }
    ]
  },
  {
    voice_id: 'TX3LPaxmHKxFdv7VOQHJ',
    name: 'Liam',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'A young adult with energy and warmth - suitable for reels and shorts.',
      labels: {
        accent: 'american',
        descriptive: 'confident',
        age: 'young',
        gender: 'male',
        language: 'en',
        use_case: 'social_media'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3',
    gender: 'male',
    description:
      'A young American male voice, confident with energy and warmth. Suitable for social media, reels, and shorts.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/63148076-6363-42db-aea8-31424308b92c.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/9d63d255-b011-4231-a945-fd5a64d94bfc.mp3'
      },
      {
        language: 'pt',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/56d7e6ac-b450-48e0-ba68-ff47921b7241.mp3'
      },
      {
        language: 'cs',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/e87b9bfb-9aee-4106-ad72-81b6982dea22.mp3'
      },
      {
        language: 'pl',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/0100273d-0f0e-4560-9803-84af8f7e8809.mp3'
      },
      {
        language: 'tr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/172d9bf5-8094-4438-b06f-b382ead09a2f.mp3'
      },
      {
        language: 'hi',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/TX3LPaxmHKxFdv7VOQHJ/437fbcd7-782a-42c0-b813-307a2e5089d6.mp3'
      }
    ]
  },
  {
    voice_id: 'XB0fDUnXU5powFXDhCwa',
    name: 'Charlotte',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        "Sensual and raspy, she's ready to voice your temptress in video games.",
      labels: {
        accent: 'swedish',
        descriptive: 'relaxed',
        age: 'young',
        gender: 'female',
        language: 'en',
        use_case: 'characters_animation'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3',
    gender: 'female',
    description:
      'A young Swedish female voice, relaxed with a sensual and raspy quality. Ideal for characters and animation, particularly for temptress roles in video games.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/942356dc-f10d-4d89-bda5-4f8505ee038b.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/6f0eaf62-7c58-437f-8d54-58a3f5281d52.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/ce1698e0-4153-4568-9a1f-d229e1cbb103.mp3'
      },
      {
        language: 'cs',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/e8fee45c-d6bc-4ad0-a186-2c46b4242bb7.mp3'
      },
      {
        language: 'es',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/98da4ec4-5232-4fe3-a1ce-ea0374dcb9e0.mp3'
      },
      {
        language: 'sv',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XB0fDUnXU5powFXDhCwa/56733b9d-3a49-4cc9-abf3-7bb39156114a.mp3'
      }
    ]
  },
  {
    voice_id: 'Xb7hH8MSUJpSbSDYk0k2',
    name: 'Alice',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'Clear and engaging, friendly woman with a British accent suitable for e-learning.',
      labels: {
        accent: 'british',
        descriptive: 'professional',
        age: 'middle_aged',
        gender: 'female',
        language: 'en',
        use_case: 'advertisement'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3',
    gender: 'female',
    description:
      'A middle-aged British female voice, clear, engaging, and friendly. Her professional tone is suitable for e-learning and advertisements.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/d10f7534-11f6-41fe-a012-2de1e482d336.mp3'
      },
      {
        language: 'it',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/5cb52c82-8152-47f0-a959-58df75b33fac.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/8078faa3-8ac4-4e55-b9ae-2d43a17fba42.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/0d220e32-be6e-42b5-b478-38dd287887c8.mp3'
      },
      {
        language: 'ja',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/290e5e0e-485a-4206-9f86-b687eed71132.mp3'
      },
      {
        language: 'pl',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/bed01e1d-3dec-4c78-bb58-c3e7299cec23.mp3'
      },
      {
        language: 'hi',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/Xb7hH8MSUJpSbSDYk0k2/063f6922-9fc5-44d7-b9ca-d5b0ed6eeb98.mp3'
      }
    ]
  },
  {
    voice_id: 'XrExE9yKIg1WjnnlVkGX',
    name: 'Matilda',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'A professional woman with a pleasing alto pitch. Suitable for many use cases.',
      labels: {
        accent: 'american',
        descriptive: 'upbeat',
        age: 'middle_aged',
        gender: 'female',
        language: 'en',
        use_case: 'informative_educational'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3',
    gender: 'female',
    description:
      'A middle-aged American female voice, professional and upbeat with a pleasing alto pitch. Suitable for many use cases, particularly informative and educational content.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/b930e18d-6b4d-466e-bab2-0ae97c6d8535.mp3'
      },
      {
        language: 'it',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/68da6da6-38b0-4de9-b941-1345c4503948.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/40f2148b-d09e-4f24-97b6-66aafef1b0bb.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/9d8aab27-268f-4fea-9815-7da3938539d1.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/3c5bb9c4-a406-4d10-b61d-275c18e84f26.mp3'
      },
      {
        language: 'es',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/XrExE9yKIg1WjnnlVkGX/20291a6d-1e7f-45e4-9d85-a764997a2fdb.mp3'
      }
    ]
  },
  {
    voice_id: 'bIHbv24MWmeRgasZH58o',
    name: 'Will',
    provider_name: 'eleven_labs',
    provider_props: {
      description: '', // Original description is empty
      labels: {
        accent: '', // Accent not specified
        descriptive: 'friendly',
        age: 'young',
        gender: 'male',
        language: 'en',
        use_case: 'social media'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8caf8f3d-ad29-4980-af41-53f20c72d7a4.mp3',
    gender: 'male',
    description:
      'A young male voice with a friendly tone. Well-suited for social media applications.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8caf8f3d-ad29-4980-af41-53f20c72d7a4.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8caf8f3d-ad29-4980-af41-53f20c72d7a4.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8caf8f3d-ad29-4980-af41-53f20c72d7a4.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8caf8f3d-ad29-4980-af41-53f20c72d7a4.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8caf8f3d-ad29-4980-af41-53f20c72d7a4.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8caf8f3d-ad29-4980-af41-53f20c72d7a4.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8caf8f3d-ad29-4980-af41-53f20c72d7a4.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/a46e8450-1b81-4370-adbc-f6b504a409ad.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/20efefbb-9e19-4808-97f1-9c7ae0eebf7b.mp3'
      },
      {
        language: 'pt',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/8e6ace43-9e5a-413d-a491-2ec365e0a2ae.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/2c7ea680-0d76-4ac5-a77a-765e59417560.mp3'
      },
      {
        language: 'cs',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/b6b630a8-eda6-4972-a527-bfcde1df0b7c.mp3'
      },
      {
        language: 'fil',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/7890ca34-065a-4d2f-a2db-2102909c96a4.mp3'
      },
      {
        language: 'sk',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/3dc86617-878a-4964-a464-3b9d39113d2a.mp3'
      },
      {
        language: 'es',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/9b17b1ba-98f6-4c6d-9da7-dc03a76bc50c.mp3'
      },
      {
        language: 'sv',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/bIHbv24MWmeRgasZH58o/090d5fe3-c80a-4990-b536-e83f33d23fe1.mp3'
      }
    ]
  },
  {
    voice_id: 'cgSgspJ2msm6clMCkdW9',
    name: 'Jessica',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'Young and popular, this playful American female voice is perfect for trendy content.',
      labels: {
        accent: 'american',
        descriptive: 'cute',
        age: 'young',
        gender: 'female',
        language: 'en',
        use_case: 'conversational'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3',
    gender: 'female',
    description:
      'A young American female voice, popular, playful, and cute. Perfect for trendy conversational content.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/56a97bf8-b69b-448f-846c-c3a11683d45a.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/83ed5b34-be48-4473-93f8-58633129bc87.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/114425d8-26e7-4b3d-aa31-52ab8bbdcbed.mp3'
      },
      {
        language: 'ja',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/a4011375-88c2-4469-a61b-96b0fb239caf.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/6f4a6924-34c9-465a-9017-707f7e823e24.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/eb773c99-fcf2-4f0c-ace5-84dc43880c34.mp3'
      },
      {
        language: 'cs',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/9fdd6daa-383a-47b8-97be-fbec0cfbe4e2.mp3'
      },
      {
        language: 'hi',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cgSgspJ2msm6clMCkdW9/3a9a4248-9eb3-4e12-8823-f3766c3fd48f.mp3'
      }
    ]
  },
  {
    voice_id: 'cjVigY5qzO86Huf0OWal',
    name: 'Eric',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'A smooth tenor pitch from a man in his 40s - perfect for agentic use cases.',
      labels: {
        accent: 'american',
        descriptive: 'classy',
        age: 'middle_aged',
        gender: 'male',
        language: 'en',
        use_case: 'conversational'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3',
    gender: 'male',
    description:
      'A middle-aged American male voice with a smooth, classy tenor pitch. Perfect for agentic and conversational use cases.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/d098fda0-6456-4030-b3d8-63aa048c9070.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/4c076868-22c6-42a6-9edd-b836f6a33f9f.mp3'
      },
      {
        language: 'pt',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/c893545f-603a-4023-ae26-0b779ab9e8c2.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/e8e9e810-3ef3-4992-a61f-4a43279b6909.mp3'
      },
      {
        language: 'sk',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/99655517-0f65-49b4-8d88-bd2a40821e65.mp3'
      },
      {
        language: 'es',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/cjVigY5qzO86Huf0OWal/4d56a844-3fc5-4048-b8d9-daff582c2746.mp3'
      }
    ]
  },
  {
    voice_id: 'iP95p4xoKVk53GoZ742B',
    name: 'Chris',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'Natural and real, this down-to-earth voice is great across many use-cases.',
      labels: {
        accent: 'american',
        descriptive: 'casual',
        age: 'middle_aged',
        gender: 'male',
        language: 'en',
        use_case: 'conversational'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3',
    gender: 'male',
    description:
      'A middle-aged American male voice, natural, real, and down-to-earth. His casual tone is great for many conversational use cases.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/3f4bde72-cc48-40dd-829f-57fbf906f4d7.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/34ab53c0-7f77-4624-a26b-65b58394ea69.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/ffdde76f-4afa-4933-94fc-6c015b4b497e.mp3'
      },
      {
        language: 'pt',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/00131b8d-38d7-4f63-91ed-91ddbe227a7d.mp3'
      },
      {
        language: 'sv',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/8710d1a0-bea3-41c9-a051-e5a4593f6a32.mp3'
      },
      {
        language: 'hi',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/iP95p4xoKVk53GoZ742B/a0a92736-9321-4bbc-9677-c84b84d3f30b.mp3'
      }
    ]
  },
  {
    voice_id: 'nPczCjzI2devNBz1zQrb',
    name: 'Brian',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'Middle-aged man with a resonant and comforting tone. Great for narrations and advertisements.',
      labels: {
        accent: 'american',
        descriptive: 'classy',
        age: 'middle_aged',
        gender: 'male',
        language: 'en',
        use_case: 'social_media' // While specified as social media, the description points more to narration/ads
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/2dd3e72c-4fd3-42f1-93ea-abc5d4e5aa1d.mp3',
    gender: 'male',
    description:
      'A middle-aged American male voice with a resonant, classy, and comforting tone. Great for narrations, advertisements, and social media.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/2dd3e72c-4fd3-42f1-93ea-abc5d4e5aa1d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/2dd3e72c-4fd3-42f1-93ea-abc5d4e5aa1d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/2dd3e72c-4fd3-42f1-93ea-abc5d4e5aa1d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/2dd3e72c-4fd3-42f1-93ea-abc5d4e5aa1d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/2dd3e72c-4fd3-42f1-93ea-abc5d4e5aa1d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/2dd3e72c-4fd3-42f1-93ea-abc5d4e5aa1d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/2dd3e72c-4fd3-42f1-93ea-abc5d4e5aa1d.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/e56be0c3-fc89-4529-8248-9726d42175fb.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/0bfb8e30-e0e8-44d9-9276-22af13da50b3.mp3'
      },
      {
        language: 'pt',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/7c88e63a-f321-40d6-ac25-899559a3ff26.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/0b33b286-75f0-404f-bcec-68a56e6b37e8.mp3'
      },
      {
        language: 'nl',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/d3e8efb2-0c52-4288-85d7-4fde1ea4b9cf.mp3'
      },
      {
        language: 'sk',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/f743b7c8-71b8-447a-9744-d66d11dcabac.mp3'
      },
      {
        language: 'ro',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/75b05b25-29ce-44b8-bbc4-f42600da8c5c.mp3'
      },
      {
        language: 'hi',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/nPczCjzI2devNBz1zQrb/945c1b51-4743-43ae-b0e7-7cab7e08a85e.mp3'
      }
    ]
  },
  {
    voice_id: 'onwK4e9ZLuTAKqWW03F9',
    name: 'Daniel',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'A strong voice perfect for delivering a professional broadcast or news story.',
      labels: {
        accent: 'british',
        descriptive: 'formal',
        age: 'middle_aged',
        gender: 'male',
        language: 'en',
        use_case: 'informative_educational'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3',
    gender: 'male',
    description:
      'A middle-aged British male voice, strong and formal. Perfect for delivering professional broadcasts, news stories, and informative educational content.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7eee0236-1a72-4b86-b303-5dcadc007ba9.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/7c30c661-8448-4a1e-b7b7-b5b629ec641b.mp3'
      },
      {
        language: 'tr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/onwK4e9ZLuTAKqWW03F9/f56723eb-7529-4617-bc87-5cf65658e538.mp3'
      }
    ]
  },
  {
    voice_id: 'pqHfZKP75CvOlQylNhV4',
    name: 'Bill',
    provider_name: 'eleven_labs',
    provider_props: {
      description:
        'Friendly and comforting voice ready to narrate your stories.',
      labels: {
        accent: 'american',
        descriptive: 'crisp',
        age: 'old',
        gender: 'male',
        language: 'en',
        use_case: 'advertisement'
      }
    },
    sample_audio:
      'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3',
    gender: 'male',
    description:
      'An old American male voice, friendly, crisp, and comforting. Ready to narrate your stories or for advertisement use.',
    languages: [
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3'
      },
      {
        language: 'en',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/d782b3ff-84ba-4029-848c-acf01285524d.mp3'
      },
      {
        language: 'fr',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/ef978e66-26c2-446e-94fc-81b4362d71b1.mp3'
      },
      {
        language: 'ar',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/617b7973-2e00-462e-bcd9-dc324db17ecc.mp3'
      },
      {
        language: 'zh',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/3e232368-c1ea-4548-a41d-048c8406a645.mp3'
      },
      {
        language: 'de',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/a1eee806-7c72-46c4-9270-dc9256ddffe6.mp3'
      },
      {
        language: 'cs',
        sample_audio:
          'https://storage.googleapis.com/eleven-public-prod/premade/voices/pqHfZKP75CvOlQylNhV4/bf99c000-ca7f-4445-847c-b01e00ec063b.mp3'
      }
    ]
  }
];
const DEEPGRAM_VOICES: AgentVoice[] = [
  {
    voice_id: 'aura-2-amalthea-en',
    name: 'Amalthea',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'Filipino',
        age: 'Young Adult',
        color: '#A1D7FD',
        image: 'https://static.deepgram.com/examples/avatars/amalthea.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-amalthea.wav',
        tags: ['feminine', 'engaging', 'natural', 'cheerful'],
        use_cases: ['casual chat']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-amalthea.wav',
    gender: 'female',
    description:
      'A young adult Filipino female voice. Engaging, natural, and cheerful, perfect for casual chat.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-andromeda-en',
    name: 'Andromeda',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#A1D7FD',
        image: 'https://static.deepgram.com/examples/avatars/andromeda.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-andromeda.wav',
        tags: ['feminine', 'casual', 'expressive', 'comfortable'],
        use_cases: ['customer service', 'IVR']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-andromeda.wav',
    gender: 'female',
    description:
      'An adult American female voice. Casual, expressive, and comfortable, suitable for customer service and IVR.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-apollo-en',
    name: 'Apollo',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#A1D7FD',
        image: 'https://static.deepgram.com/examples/avatars/apollo.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-apollo.wav',
        tags: ['masculine', 'confident', 'comfortable', 'casual'],
        use_cases: ['casual chat']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-apollo.wav',
    gender: 'male',
    description:
      'An adult American male voice. Confident, comfortable, and casual, ideal for casual chat.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-arcas-en',
    name: 'Arcas',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#EE028C',
        image: 'https://static.deepgram.com/examples/avatars/arcas.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-arcas.wav',
        tags: ['masculine', 'natural', 'smooth', 'clear', 'comfortable'],
        use_cases: ['customer service', 'casual chat']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-arcas.wav',
    gender: 'male',
    description:
      'An adult American male voice. Natural, smooth, clear, and comfortable, suitable for customer service and casual chat.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-aries-en',
    name: 'Aries',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#EE028C',
        image: 'https://static.deepgram.com/examples/avatars/aries.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-aries.wav',
        tags: ['masculine', 'warm', 'energetic', 'caring'],
        use_cases: ['casual chat']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-aries.wav',
    gender: 'male',
    description:
      'An adult American male voice. Warm, energetic, and caring, perfect for casual chat.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-asteria-en',
    name: 'Asteria',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#7800ED',
        image: 'https://static.deepgram.com/examples/avatars/asteria.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-asteria.wav',
        tags: ['feminine', 'clear', 'confident', 'knowledgeable', 'energetic'],
        use_cases: ['advertising']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-asteria.wav',
    gender: 'female',
    description:
      'An adult American female voice. Clear, confident, knowledgeable, and energetic, ideal for advertising.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-athena-en',
    name: 'Athena',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Mature',
        color: '#F04438',
        image: 'https://static.deepgram.com/examples/avatars/athena.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-athena.wav',
        tags: ['feminine', 'calm', 'smooth', 'professional'],
        use_cases: ['storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-athena.wav',
    gender: 'female',
    description:
      'A mature American female voice. Calm, smooth, and professional, excellent for storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-atlas-en',
    name: 'Atlas',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Mature',
        color: '#7800ED',
        image: 'https://static.deepgram.com/examples/avatars/atlas.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-atlas.wav',
        tags: [
          'masculine',
          'enthusiastic',
          'confident',
          'approachable',
          'friendly'
        ],
        use_cases: ['advertising']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-atlas.wav',
    gender: 'male',
    description:
      'A mature American male voice. Enthusiastic, confident, approachable, and friendly, great for advertising.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-aurora-en',
    name: 'Aurora',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#949498',
        image: 'https://static.deepgram.com/examples/avatars/aurora.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-aurora.wav',
        tags: ['feminine', 'cheerful', 'expressive', 'energetic'],
        use_cases: ['interview']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-aurora.wav',
    gender: 'female',
    description:
      'An adult American female voice. Cheerful, expressive, and energetic, suitable for interviews.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-callista-en',
    name: 'Callista',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#027A48',
        image: 'https://static.deepgram.com/examples/avatars/callista.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-callista.wav',
        tags: ['feminine', 'clear', 'energetic', 'professional', 'smooth'],
        use_cases: ['IVR']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-callista.wav',
    gender: 'female',
    description:
      'An adult American female voice. Clear, energetic, professional, and smooth, perfect for IVR systems.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-cora-en',
    name: 'Cora',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FFADD8',
        image: 'https://static.deepgram.com/examples/avatars/cora.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-cora.wav',
        tags: ['feminine', 'smooth', 'melodic', 'caring'],
        use_cases: ['storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-cora.wav',
    gender: 'female',
    description:
      'An adult American female voice. Smooth, melodic, and caring, ideal for storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-cordelia-en',
    name: 'Cordelia',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Young Adult',
        color: '#EE028C',
        image: 'https://static.deepgram.com/examples/avatars/cordelia.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-cordelia.wav',
        tags: ['feminine', 'approachable', 'warm', 'polite'],
        use_cases: ['storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-cordelia.wav',
    gender: 'female',
    description:
      'A young adult American female voice. Approachable, warm, and polite, suitable for storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-delia-en',
    name: 'Delia',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Young Adult',
        color: '#FFADD8',
        image: 'https://static.deepgram.com/examples/avatars/delia.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-delia.wav',
        tags: ['feminine', 'casual', 'friendly', 'cheerful', 'breathy'],
        use_cases: ['interview']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-delia.wav',
    gender: 'female',
    description:
      'A young adult American female voice. Casual, friendly, cheerful, and breathy, great for interviews.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-draco-en',
    name: 'Draco',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'British',
        age: 'Adult',
        color: '#EE028C',
        image: 'https://static.deepgram.com/examples/avatars/draco.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-draco.wav',
        tags: ['masculine', 'warm', 'approachable', 'trustworthy', 'baritone'],
        use_cases: ['storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-draco.wav',
    gender: 'male',
    description:
      'An adult British male voice. Warm, approachable, trustworthy, with a baritone quality, perfect for storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-electra-en',
    name: 'Electra',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FEC84B',
        image: 'https://static.deepgram.com/examples/avatars/electra.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-electra.wav',
        tags: ['feminine', 'professional', 'engaging', 'knowledgeable'],
        use_cases: ['IVR', 'advertising', 'customer service']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-electra.wav',
    gender: 'female',
    description:
      'An adult American female voice. Professional, engaging, and knowledgeable, suitable for IVR, advertising, and customer service.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-harmonia-en',
    name: 'Harmonia',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FFE699',
        image: 'https://static.deepgram.com/examples/avatars/harmonia.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-harmonia.wav',
        tags: ['feminine', 'empathetic', 'clear', 'calm', 'confident'],
        use_cases: ['customer service']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-harmonia.wav',
    gender: 'female',
    description:
      'An adult American female voice. Empathetic, clear, calm, and confident, ideal for customer service.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-helena-en',
    name: 'Helena',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#7800ED',
        image: 'https://static.deepgram.com/examples/avatars/helena.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-helena.wav',
        tags: [
          'feminine',
          'caring',
          'natural',
          'positive',
          'friendly',
          'raspy'
        ],
        use_cases: ['IVR', 'casual chat']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-helena.wav',
    gender: 'female',
    description:
      'An adult American female voice. Caring, natural, positive, friendly, and raspy, suitable for IVR and casual chat.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-hera-en',
    name: 'Hera',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#949498',
        image: 'https://static.deepgram.com/examples/avatars/hera.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-hera.wav',
        tags: ['feminine', 'smooth', 'warm', 'professional'],
        use_cases: ['storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-hera.wav',
    gender: 'female',
    description:
      'An adult American female voice. Smooth, warm, and professional, excellent for storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-hermes-en',
    name: 'Hermes',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#C58DFF',
        image: 'https://static.deepgram.com/examples/avatars/hermes.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-thalia.wav',
        tags: ['masculine', 'expressive', 'engaging', 'professional'],
        use_cases: ['informative']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-thalia.wav',
    gender: 'male',
    description:
      'An adult American male voice. Expressive, engaging, and professional, great for informative content.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-hyperion-en',
    name: 'Hyperion',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'Australian',
        age: 'Adult',
        color: '#79AFFA',
        image: 'https://static.deepgram.com/examples/avatars/hyperion.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-hyperion.wav',
        tags: ['masculine', 'caring', 'warm', 'empathetic'],
        use_cases: ['interview']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-hyperion.wav',
    gender: 'male',
    description:
      'An adult Australian male voice. Caring, warm, and empathetic, suitable for interviews.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-iris-en',
    name: 'Iris',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Young Adult',
        color: '#949498',
        image: 'https://static.deepgram.com/examples/avatars/iris.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-iris.wav',
        tags: ['feminine', 'cheerful', 'positive', 'approachable'],
        use_cases: ['IVR']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-iris.wav',
    gender: 'female',
    description:
      'A young adult American female voice. Cheerful, positive, and approachable, perfect for IVR systems.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-janus-en',
    name: 'Janus',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#075433',
        image: 'https://static.deepgram.com/examples/avatars/janus.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-janus.wav',
        tags: ['feminine', 'southern', 'smooth', 'trustworthy'],
        use_cases: ['storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-janus.wav',
    gender: 'female',
    description:
      'An adult American female voice with a southern accent. Smooth and trustworthy, ideal for storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-juno-en',
    name: 'Juno',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#C58DFF',
        image: 'https://static.deepgram.com/examples/avatars/juno.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-juno.wav',
        tags: ['feminine', 'natural', 'engaging', 'melodic', 'breathy'],
        use_cases: ['interview']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-juno.wav',
    gender: 'female',
    description:
      'An adult American female voice. Natural, engaging, melodic, and breathy, suitable for interviews.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-jupiter-en',
    name: 'Jupiter',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FEC84B',
        image: 'https://static.deepgram.com/examples/avatars/jupiter.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-jupiter.wav',
        tags: ['masculine', 'expressive', 'knowledgeable', 'baritone'],
        use_cases: ['informative']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-jupiter.wav',
    gender: 'male',
    description:
      'An adult American male voice. Expressive, knowledgeable, with a baritone quality, great for informative content.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-luna-en',
    name: 'Luna',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Young Adult',
        color: '#949498',
        image: 'https://static.deepgram.com/examples/avatars/luna.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-luna.wav',
        tags: ['feminine', 'friendly', 'natural', 'engaging'],
        use_cases: ['IVR']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-luna.wav',
    gender: 'female',
    description:
      'A young adult American female voice. Friendly, natural, and engaging, perfect for IVR systems.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-mars-en',
    name: 'Mars',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FFADD8',
        image: 'https://static.deepgram.com/examples/avatars/mars.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-mars.wav',
        tags: ['masculine', 'smooth', 'patient', 'trustworthy', 'baritone'],
        use_cases: ['customer service']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-mars.wav',
    gender: 'male',
    description:
      'An adult American male voice. Smooth, patient, trustworthy, with a baritone quality, ideal for customer service.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-minerva-en',
    name: 'Minerva',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#A1D7FD',
        image: 'https://static.deepgram.com/examples/avatars/minerva.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-minerva.wav',
        tags: ['feminine', 'positive', 'friendly', 'natural'],
        use_cases: ['storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-minerva.wav',
    gender: 'female',
    description:
      'An adult American female voice. Positive, friendly, and natural, suitable for storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-neptune-en',
    name: 'Neptune',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#F04438',
        image: 'https://static.deepgram.com/examples/avatars/neptune.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-neptune.wav',
        tags: ['masculine', 'professional', 'patient', 'polite'],
        use_cases: ['customer service']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-neptune.wav',
    gender: 'male',
    description:
      'An adult American male voice. Professional, patient, and polite, great for customer service.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-odysseus-en',
    name: 'Odysseus',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#F04438',
        image: 'https://static.deepgram.com/examples/avatars/odysseus.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-odysseus.wav',
        tags: ['masculine', 'calm', 'smooth', 'comfortable', 'professional'],
        use_cases: ['advertising']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-odysseus.wav',
    gender: 'male',
    description:
      'An adult American male voice. Calm, smooth, comfortable, and professional, perfect for advertising.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-ophelia-en',
    name: 'Ophelia',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FFADD8',
        image: 'https://static.deepgram.com/examples/avatars/ophelia.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-ophelia.wav',
        tags: ['feminine', 'expressive', 'enthusiastic', 'cheerful'],
        use_cases: ['interview']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-ophelia.wav',
    gender: 'female',
    description:
      'An adult American female voice. Expressive, enthusiastic, and cheerful, ideal for interviews.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-orion-en',
    name: 'Orion',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#A1D7FD',
        image: 'https://static.deepgram.com/examples/avatars/orion.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-orion.wav',
        tags: ['masculine', 'approachable', 'comfortable', 'calm', 'polite'],
        use_cases: ['informative']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-orion.wav',
    gender: 'male',
    description:
      'An adult American male voice. Approachable, comfortable, calm, and polite, suitable for informative content.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-orpheus-en',
    name: 'Orpheus',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#A1F9D4',
        image: 'https://static.deepgram.com/examples/avatars/orpheus.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-orpheus.wav',
        tags: [
          'masculine',
          'professional',
          'clear',
          'confident',
          'trustworthy'
        ],
        use_cases: ['customer service', 'storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-orpheus.wav',
    gender: 'male',
    description:
      'An adult American male voice. Professional, clear, confident, and trustworthy, great for customer service and storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-pandora-en',
    name: 'Pandora',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'British',
        age: 'Adult',
        color: '#FEDF89',
        image: 'https://static.deepgram.com/examples/avatars/pandora.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-pandora.wav',
        tags: ['feminine', 'smooth', 'calm', 'melodic', 'breathy'],
        use_cases: ['IVR']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-pandora.wav',
    gender: 'female',
    description:
      'An adult British female voice. Smooth, calm, melodic, and breathy, suitable for IVR.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-phoebe-en',
    name: 'Phoebe',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#EE028C',
        image: 'https://static.deepgram.com/examples/avatars/phoebe.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-phoebe.wav',
        tags: ['feminine', 'energetic', 'warm', 'casual'],
        use_cases: ['customer service']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-phoebe.wav',
    gender: 'female',
    description:
      'An adult American female voice. Energetic, warm, and casual, suitable for customer service.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-pluto-en',
    name: 'Pluto',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#027A48',
        image: 'https://static.deepgram.com/examples/avatars/pluto.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-pluto.wav',
        tags: ['masculine', 'smooth', 'calm', 'empathetic', 'baritone'],
        use_cases: ['interview', 'storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-pluto.wav',
    gender: 'male',
    description:
      'An adult American male voice. Smooth, calm, empathetic, with a baritone quality, suitable for interviews and storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-saturn-en',
    name: 'Saturn',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FEC84B',
        image: 'https://static.deepgram.com/examples/avatars/saturn.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-saturn.wav',
        tags: ['masculine', 'knowledgeable', 'confident', 'baritone'],
        use_cases: ['customer service']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-saturn.wav',
    gender: 'male',
    description:
      'An adult American male voice. Knowledgeable, confident, with a baritone quality, suitable for customer service.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-selene-en',
    name: 'Selene',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#F04438',
        image: 'https://static.deepgram.com/examples/avatars/selene.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-selene.wav',
        tags: ['feminine', 'expressive', 'engaging', 'energetic'],
        use_cases: ['informative']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-selene.wav',
    gender: 'female',
    description:
      'An adult American female voice. Expressive, engaging, and energetic, suitable for informative content.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-thalia-en',
    name: 'Thalia',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FFE699',
        image: 'https://static.deepgram.com/examples/avatars/thalia.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-thalia.wav',
        tags: ['feminine', 'clear', 'confident', 'energetic', 'enthusiastic'],
        use_cases: ['casual chat', 'customer service', 'IVR']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-thalia.wav',
    gender: 'female',
    description:
      'An adult American female voice. Clear, confident, energetic, and enthusiastic, suitable for casual chat, customer service, and IVR.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-theia-en',
    name: 'Theia',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#FEC84B',
        image: 'https://static.deepgram.com/examples/avatars/theia.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-theia.wav',
        tags: ['feminine', 'expressive', 'polite', 'sincere'],
        use_cases: ['informative']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-theia.wav',
    gender: 'female',
    description:
      'An adult American female voice. Expressive, polite, and sincere, suitable for informative content.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-vesta-en',
    name: 'Vesta',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#149AFB',
        image: 'https://static.deepgram.com/examples/avatars/vesta.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-vesta.wav',
        tags: ['feminine', 'natural', 'expressive', 'patient', 'empathetic'],
        use_cases: ['customer service', 'interview', 'storytelling']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-vesta.wav',
    gender: 'female',
    description:
      'An adult American female voice. Natural, expressive, patient, and empathetic, suitable for customer service, interviews, and storytelling.',
    languages: [
      {
        language: 'en'
      }
    ]
  },
  {
    voice_id: 'aura-2-zeus-en',
    name: 'Zeus',
    provider_name: 'deepgram',
    provider_props: {
      metadata: {
        accent: 'American',
        age: 'Adult',
        color: '#C58DFF',
        image: 'https://static.deepgram.com/examples/avatars/zeus.jpg',
        sample: 'https://static.deepgram.com/examples/Aura-2-zeus.wav',
        tags: ['masculine', 'deep', 'trustworthy', 'smooth'],
        use_cases: ['IVR']
      }
    },
    sample_audio: 'https://static.deepgram.com/examples/Aura-2-zeus.wav',
    gender: 'male',
    description:
      'An adult American male voice. Deep, trustworthy, and smooth, suitable for IVR.',
    languages: [
      {
        language: 'en'
      }
    ]
  }
];

export function voiceLangCodeToLabel(langCode: string) {
  return {
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    de: 'German',
    it: 'Italian',
    pt: 'Portuguese',
    ru: 'Russian',
    ja: 'Japanese',
    ko: 'Korean',
    zh: 'Chinese',
    ar: 'Arabic',
    hi: 'Hindi',
    bn: 'Bengali',
    nl: 'Dutch',
    pl: 'Polish',
    ro: 'Romanian',
    sv: 'Swedish',
    tr: 'Turkish',
    uk: 'Ukrainian',
    vi: 'Vietnamese',
    id: 'Indonesian',
    ms: 'Malay',
    th: 'Thai',
    la: 'Lao',
    km: 'Khmer',
    lo: 'Lao',
    my: 'Myanmar',
    fil: 'Filipino',
    ph: 'Filipino',
    ta: 'Tamil',
    te: 'Telugu',
    mr: 'Marathi',
    gu: 'Gujarati',
    pa: 'Punjabi',
    or: 'Oriya'
  }[langCode];
}

export const OPENAI_VOICES = [
  { value: 'alloy', name: 'Alloy', extension: 'wav', gender: 'female' },
  { value: 'ash', name: 'Ash', extension: 'flac', gender: 'male' },
  { value: 'ballad', name: 'Ballad', extension: 'flac', gender: 'male' },
  { value: 'coral', name: 'Coral', extension: 'flac', gender: 'female' },
  { value: 'echo', name: 'Echo', extension: 'wav', gender: 'male' },
  { value: 'fable', name: 'Fable', extension: 'wav', gender: 'female' },
  { value: 'onyx', name: 'Onyx', extension: 'wav', gender: 'male' },
  { value: 'nova', name: 'Nova', extension: 'wav', gender: 'female' },
  { value: 'sage', name: 'Sage', extension: 'flac', gender: 'female' },
  { value: 'shimmer', name: 'Shimmer', extension: 'wav', gender: 'female' },
  { value: 'verse', name: 'Verse', extension: 'flac', gender: 'male' }
];

export function getOpenAIVoiceModel(voice: string) {
  return OPENAI_VOICES.find(v => v.value === voice)?.value || 'shimmer';
}

export const AGENT_VOICES: AgentVoice[] = [
  ...DEEPGRAM_VOICES,
  ...ELEVEN_LABS_VOICES
].map(voice => {
  const languages = Array.from(
    new Set(voice.languages.map(language => language.language))
  );
  return {
    ...voice,
    languages: languages
      .map(lang => ({
        language: voiceLangCodeToLabel(lang) as string
      }))
      .filter(lang => lang.language)
  };
});

export function findVoice(voiceId: string) {
  return AGENT_VOICES.find(voice => voice.voice_id === voiceId);
}
